import { IRootReducer } from '../../types/reducerTypes'

export const selectUser = ({ user }: IRootReducer) => user
